import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useGameInfoEnabled = (): boolean => {
  const isMobile = useSelector(select.device.isMobile);
  const enabled = useFeature(FeatureFlag.CasinoGameInfo);
  const mobile = useFeature(FeatureFlag.CasinoGameInfoMobile);
  const desktop = useFeature(FeatureFlag.CasinoGameInfoDesktop);

  return !enabled
    ? enabled
    : (mobile && isMobile) || (desktop && !isMobile) || (!mobile && !desktop);
};

export default useGameInfoEnabled;
